import { render, staticRenderFns } from "./PmAreaCardView.vue?vue&type=template&id=31fae96c&scoped=true&"
import script from "./PmAreaCardView.vue?vue&type=script&lang=js&"
export * from "./PmAreaCardView.vue?vue&type=script&lang=js&"
import style0 from "./PmAreaCardView.vue?vue&type=style&index=0&id=31fae96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fae96c",
  null
  
)

export default component.exports